import AdvertiserDashboard from '../views/AdvertiserDashboard';
import AdvertiserList      from '../views/AdvertiserList';
import { Route }           from 'react-router-dom';

export default [
  <Route element={<AdvertiserList />} key="list" path="/annonceurs" />,
  <Route element={<AdvertiserDashboard />} key="show" path="/annonceurs/:advertiserId" />,
];
